import { Box, Grid, alpha } from "@mui/material";
import styled from "styled-components";

export const BackButton = styled(Box)`
	display: inline-flex;
	align-items: center;
	gap: 10px;
	cursor: pointer;
	padding: 6px 18px 6px 6px;
	border-radius: 999px;
	background: #fff;
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
	transition:
		box-shadow 0.2s ease,
		transform 0.2s ease;
	width: fit-content;

	.MuiIconButton-root {
		width: 34px;
		height: 34px;
		background: ${({ theme }) => alpha(theme.custom_palette.color1, 0.12)};
		color: ${({ theme }) => theme.custom_palette.color1};
		transition:
			background 0.2s ease,
			color 0.2s ease;

		svg {
			font-size: 18px;
		}
	}

	.MuiTypography-root {
		font-weight: 700;
		font-size: 14px;
		color: ${({ theme }) => theme.palette.text.primary};
	}

	&:hover {
		box-shadow: 0 8px 22px rgba(0, 0, 0, 0.1);
		transform: translateY(-1px);

		.MuiIconButton-root {
			background: ${({ theme }) => theme.custom_palette.color1};
			color: #fff;
		}
	}

	&:active {
		transform: translateY(0);
	}
`;

export const MyAccountContainer = styled(Grid)`
	.menu {
		position: sticky;
		top: 65px;
		z-index: 1;
		background: #fff;
		border-radius: 18px;
		padding: 10px;
		box-shadow: 0 6px 24px rgba(0, 0, 0, 0.06);

		${props => props.theme.breakpoints.down("md")} {
			border-radius: 999px;
			padding: 6px;
		}
	}
	.menu-tabs {
		display: flex;
		flex-direction: column;
		gap: 6px;
		padding: 0;

		.MuiMenuItem-root {
			background: transparent;
			border-radius: 14px;
			padding: 0;
			transition:
				background 0.2s ease,
				transform 0.2s ease;

			&:hover {
				background: ${({ theme }) => alpha(theme.custom_palette.color1, 0.08)};
			}

			.MuiListItemButton-root {
				padding: 10px 14px;
				border-radius: 14px;
				gap: 12px;
			}

			.MuiListItemIcon-root {
				min-width: unset;
				width: 36px;
				height: 36px;
				border-radius: 10px;
				display: flex;
				align-items: center;
				justify-content: center;
				background: ${({ theme }) => alpha(theme.custom_palette.color1, 0.12)};
				color: ${({ theme }) => theme.custom_palette.color1};
				transition:
					background 0.2s ease,
					color 0.2s ease;

				svg {
					font-size: 20px;
					fill: currentColor;
				}
			}
		}

		.MuiTypography-root {
			font-weight: 600;
			font-size: 14px;
			letter-spacing: 0.2px;
			color: ${({ theme }) => theme.palette.text.primary};
			transition: color 0.2s ease;
		}

		.Mui-selected {
			background: linear-gradient(
				135deg,
				${({ theme }) => theme.custom_palette.color1},
				${({ theme }) => theme.palette.primary.dark}
			) !important;
			box-shadow: ${({ theme }) => `0 6px 16px ${alpha(theme.custom_palette.color1, 0.4)}`};
			transform: translateX(2px);

			.MuiListItemIcon-root {
				background: rgba(255, 255, 255, 0.2);
				color: #fff;
			}
			.MuiTypography-root {
				color: #fff;
			}
		}

		${props => props.theme.breakpoints.down("md")} {
			flex-direction: row;
			justify-content: safe center;
			overflow-x: auto;
			scrollbar-width: none;
			-ms-overflow-style: none;
			gap: 6px;

			&::-webkit-scrollbar {
				display: none;
			}

			.MuiMenuItem-root {
				flex: 0 0 auto;
				border-radius: 999px;

				.MuiListItemButton-root {
					padding: 8px 12px;
					border-radius: 999px;
				}
			}

			.Mui-selected {
				transform: none;
			}
		}
	}
`;
